import React, { useEffect, useState } from 'react'
import { 
  Row, Col,
  FormGroup, Label, Input,
  Card, CardHeader,CardBody, 
  Button, UncontrolledTooltip
} from 'reactstrap'
import { CheckmarkOutline, CloseOutline } from 'react-ionicons'

const FieldData = [
  { label: 'Contact Person', value: 'contact_person_name', type: 'text', editable: false },
  { label: 'Contact Person Email', value: 'contact_person_email_address', type: 'text', editable: false },
  { label: 'Contact Person Phone', value: 'contact_person_phone_number', type: 'text', editable: false },
  { label: 'Contact Person Mobile', value: 'contact_person_mobile', type: 'text', editable: false },
  { label: 'Placement Form URL', value: 'url', type: 'url', editable: false },
  { label: 'Checked', value: 'is_checked', type: 'boolean', editable: false },
  { label: 'Remarks', value: 'remarks', type: 'textarea', editable: false },
  { label: 'Admin Remark', value: 'admin_remarks', type: 'textarea', editable: false },
  { label: 'Date of Submission', value: 'submitted_date_time', type: 'text', editable: false },
  { label: 'Date of Review', value: 'review_date_time', type: 'text', editable: false },
]

const PlacementForm = props => {

  const { placement_form, placement_form_id, student_name } = props.selectedAcceptedVacancies
  const { is_update } = props
  const [ formContent, setFormContent ] = useState({
    admin_remarks: "",
    contact_person_email_address: "",
    contact_person_mobile: "",
    contact_person_name: "",
    contact_person_phone_number: "",
    is_checked: false,
    remarks: "",
    url: "",
    review_date_time: null,
    submitted_date_time: null,
  })

  useEffect( () => {
    if( placement_form )
      setFormContent({ 
        ...placement_form, 
        url: `https://ims-dev-api.cs.usm.my/api/v1/placement_forms/pdf/${ placement_form_id }` 
      })
  }, [ props.selectedAcceptedVacancies ])

  return(
    <Card className="mt-2 mb-3">
      <CardHeader style={{ fontSize: '1rem', display: 'flex' }}>
        Form Details
      </CardHeader>
      <CardBody>
        <Row>
          {
            FieldData.map( data => (
              <Col lg={ 6 }>
                <FormGroup>
                  <Label>{ data.label }</Label>
                  {
                    data.type === 'boolean' && (
                      formContent[data.value]
                        ? <CheckmarkOutline cssClasses={ 'text-success d-block' }/>
                        : <CloseOutline cssClasses={ 'text-danger d-block' }/>
                    )
                  }
                  {
                    data.type === 'url' && (
                      <div>
                        {
                          formContent[data.value]
                          ? 
                            <div>
                              <Button
                                id="DownloadPlacement"
                                className="mr-2 btn-icon btn-icon-only"
                                color="warning"
                                onClick={() => props.getStudentPlacementForm_pdf(placement_form_id, student_name) }
                              >
                                <i className="pe-7s-cloud-download btn-icon-wrapper"> </i>
                              </Button>
                              <UncontrolledTooltip target="DownloadPlacement" placement="right">Download this placement form</UncontrolledTooltip>
                            </div>
                          : <span className='student-vacancy__detail-subtitle'>N/A</span>
                        }
                      </div>
                    )
                  }
                  {
                    data.type !== 'boolean' && data.type !== 'url' && (
                      <Input
                        type={ data.type }
                        value={ formContent[data.value] || 'N/A' }
                        disabled={ true }
                      />
                    )
                  }
                </FormGroup>
              </Col>
            ))
          }
        </Row>
      </CardBody>
    </Card>
  )
}

export default PlacementForm;